// Turning what the doctor picked on an order form into what the server accepts.
//
// Two kinds of test can appear in the same list: a row from the lab's own priced
// catalog, and one from the shared library the doctor switched on in settings.
// Both are ordered by reference rather than by name - the server looks the test
// up and writes the name, type and reference range itself, so the request that
// reaches the lab never says whatever the browser happened to post.

// Options for an antd Select, from what GET /api/tests/catalog returned.
export const labTestSelectOptions = (catalog = []) => catalog.map((entry) => ({
    value: entry.value,
    label: entry.price
        ? `${entry.testName} — ${entry.price} IQD`
        : entry.testName
}));

// The picked values as order entries. An entry that matches nothing in the
// catalog is dropped rather than sent as free text: it means the list was
// reloaded under the doctor, and inventing a test name from a stale id would put
// the wrong request in front of the lab.
export const labOrderEntries = (values = [], catalog = []) => {
    const byValue = new Map(catalog.map((entry) => [entry.value, entry]));

    return values
        .map((value) => byValue.get(value))
        .filter(Boolean)
        .map((entry) => (entry.source === 'library'
            ? { libraryCode: entry.libraryCode }
            : { catalogId: entry.catalogId }));
};

// What the selected tests add up to. Library tests carry no price - only the lab
// that runs them can say - so a total covers the catalog rows and nothing else.
export const labOrderTotal = (values = [], catalog = []) => {
    const byValue = new Map(catalog.map((entry) => [entry.value, entry]));
    return values.reduce((sum, value) => sum + (byValue.get(value)?.price || 0), 0);
};
